import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-lessons-list-header',
    templateUrl: './lessons-list-header.component.html',
    styleUrls: ['./lessons-list-header.component.scss']
})
export class LessonsListHeaderComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
